import { ShieldCheck, TrendingUp, HandCoins, HeartPulse } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { IMAGES } from "@/constants/config";
import { useLang } from "@/constants/i18n";

const ICONS = [ShieldCheck, TrendingUp, HandCoins, HeartPulse];

export const Iul = () => {
    const { t } = useLang();
    return (
        <section
            id="iul"
            data-testid="iul-section"
            className="grain relative overflow-hidden bg-forest py-24 text-ivory md:py-32"
        >
            <div className="pointer-events-none absolute -right-32 top-0 h-[480px] w-[480px] rounded-full bg-gold/10 blur-3xl" />
            <div className="relative z-10 mx-auto grid max-w-7xl grid-cols-1 gap-16 px-5 md:px-10 lg:grid-cols-12">
                <div className="lg:col-span-7">
                    <SectionHeading number="02" eyebrow={t.iul.eyebrow} title={t.iul.title} dark />
                    <Reveal delay={0.15} className="space-y-6 text-base leading-relaxed text-ivory/75 md:text-lg">
                        <p>
                            {t.iul.p1a}
                            <span className="font-medium text-tan">{t.iul.p1Highlight}</span>
                            {t.iul.p1b}
                        </p>
                        <p>{t.iul.p2}</p>
                    </Reveal>
                    <div className="mt-12 space-y-0">
                        {t.iul.pillars.map((pillar, i) => {
                            const Icon = ICONS[i % ICONS.length];
                            return (
                                <Reveal key={pillar.title} delay={0.15 + i * 0.1}>
                                    <div className="flex gap-6 border-t border-ivory/15 py-8">
                                        <span className="font-serif text-3xl font-light text-gold/70">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                        <Icon className="mt-1 h-6 w-6 shrink-0 text-gold" />
                                        <div>
                                            <h3 className="font-serif text-2xl text-ivory">{pillar.title}</h3>
                                            <p className="mt-2 max-w-md text-sm leading-relaxed text-ivory/65">
                                                {pillar.text}
                                            </p>
                                        </div>
                                    </div>
                                </Reveal>
                            );
                        })}
                    </div>
                    <Reveal delay={0.4}>
                        <p className="mt-6 text-xs leading-relaxed text-ivory/45">
                            {t.iul.fineprint}
                        </p>
                    </Reveal>
                </div>
                <div className="flex items-center lg:col-span-5">
                    <Reveal delay={0.2} className="relative w-full">
                        <div className="overflow-hidden border border-gold/30">
                            <img
                                src={IMAGES.forest}
                                alt={t.iul.imageAlt}
                                data-testid="iul-image"
                                className="h-[420px] w-full object-cover transition-transform duration-700 hover:scale-105 md:h-[560px]"
                            />
                        </div>
                        <div className="absolute -bottom-6 -left-6 hidden bg-burgundy px-8 py-6 md:block">
                            <p className="font-serif text-4xl font-light text-ivory">{t.iul.badgeValue}</p>
                            <p className="mt-1 text-xs uppercase tracking-[0.25em] text-tan">
                                {t.iul.badgeLabel}
                            </p>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};

export default Iul;
